import { render } from "./DownloadView.vue?vue&type=template&id=31b5d898&scoped=true&ts=true"
import script from "./DownloadView.vue?vue&type=script&lang=ts"
export * from "./DownloadView.vue?vue&type=script&lang=ts"

import "./DownloadView.vue?vue&type=style&index=0&id=31b5d898&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b5d898"]])

export default __exports__